import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";

const ACTION_LABEL = {
  create: "Creación", edit: "Edición", reprogram: "Reprogramación",
  confirmed: "Confirmación", completed: "Finalización", no_show: "No presentado",
  cancelled: "Cancelación", block: "Bloqueo", unblock: "Desbloqueo",
  config_update: "Config. actualizada", booked: "Reactivada",
};

export default function PhysioAuditDialog({ open, onOpenChange }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.get("/physio/audit").then((r) => setItems(r.data || [])).catch(() => setItems([])).finally(() => setLoading(false));
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[92vh] overflow-y-auto" data-testid="physio-audit-dialog">
        <DialogHeader>
          <DialogTitle>Auditoría de Fisioterapia</DialogTitle>
          <DialogDescription>Registro de todas las acciones (usuario, fecha y cambios).</DialogDescription>
        </DialogHeader>
        {loading && <div className="text-sm text-slate-500">Cargando…</div>}
        <div className="space-y-2">
          {!loading && items.length === 0 && <div className="text-sm text-slate-500">Sin registros todavía.</div>}
          {items.map((a) => (
            <div key={a.id} className="rounded-lg border border-slate-200 p-2 text-xs" data-testid={`physio-audit-item-${a.id}`}>
              <div className="flex items-center justify-between">
                <span className="font-bold text-purple-800">{ACTION_LABEL[a.action] || a.action}</span>
                <span className="text-slate-400">{(a.at || "").replace("T", " ").slice(0, 16)}</span>
              </div>
              <div className="text-slate-500">Por: {a.user_name || "—"}</div>
              {(a.before || a.after) && (
                <div className="text-slate-400 mt-1">
                  {a.before && <span>Antes: {JSON.stringify(a.before)} </span>}
                  {a.after && <span>Después: {JSON.stringify(a.after)}</span>}
                </div>
              )}
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
